import { createSlice } from "@reduxjs/toolkit";

export const defaultFilterParams = {
  subjectIds: [],
  brandIds: [],
  productIds: [],
  advertTypes: [],
  advertNames: [],
};

export const getFiltersFromParams = params => {
  const result = {};
  for (const key in params) {
    const value = params[key];
    if (value === "" || value == null || (Array.isArray(value) && value.length === 0)) {
      result[key] = "";
      continue;
    }
    if (key === "brandIds") {
      result["brand_id__in"] = value.map(item => item.id).join(",");
    } else if (key === "productIds") {
      result["product_id__in"] = value.map(item => item.id).join(",");
    } else if (key === "subjectIds") {
      result["subject_id__in"] = value.map(item => item.id).join(",");
    } else if (key === "advertTypes") {
      result["advert_type__in"] = value.map(item => item.advert_type).join(",");
    } else if (key === "advertNames") {
      result["advert_name__in"] = value.map(item => item.advert_name).join(",");
    } else {
      result[key] = value;
    }
  }
  console.log("{PARAMS}", result);
  return result;
};

const initialState = {
  selectedMarketplaces: ["wb"],
  filterParams: {
    ...defaultFilterParams,
  },
};

const innerResume = createSlice({
  name: "innerResume",
  initialState,
  reducers: {
    setSelectedMarketplaces: (state, action) => {
      state.selectedMarketplaces = action.payload;
    },
    setFilterParam(state, { payload: { name, value } }) {
      state.filterParams[name] = value;
    },
    resetFilterParams(state) {
      state.filterParams = { ...defaultFilterParams };
    },
  },
});

export default innerResume.reducer;

export const { setSelectedMarketplaces, setFilterParam, resetFilterParams } = innerResume.actions;
